// extracted by mini-css-extract-plugin
module.exports = {"PackagesMediaItems":"styles_PackagesMediaItems__3GjiY","packagesMediaItems":"styles_PackagesMediaItems__3GjiY"};